// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__1TgQw","text":"SelectPayment_text__1zCGz","title":"SelectPayment_title__2e77A","btn":"SelectPayment_btn__4JkIf"};